<div class="main-wrap">
  <p-toast></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <div class="body">
    <div class="tab-container">
      <p-tabMenu [model]="navigationItems" [activeItem]="activeItem"></p-tabMenu>
      <div class="saved-search-box" [formGroup]="customSearchForm" *ngIf="activeItemId==1 && customSearchForm">
        <div class="saved-searches-container">
          <p-button *ngFor="let search of bookingSearchService.favoriteSearches" [label]="search.name | titlecase"
            iconPos="right" icon="pi pi-angle-right" (onClick)="bookingSearchService.loadSavedSearchById(search!.id!)"
            pTooltip="Go !"></p-button>
        </div>
        <div *ngIf="bookingSearchService.isSavedSearchesVisible">
          <app-bookings-saved-searches></app-bookings-saved-searches>
        </div>
        <div *ngFor="let rule of bookingSearchService.searchRules; let i = index" class="search-rule-line-item">
          <span *ngIf="rule">
            <span>
              {{rule.searchAction.name}}
            </span>
            <span *ngIf="rule.searchAction.id==1 || rule.searchAction.id==2">
              to result
            </span>
            <span *ngIf="rule.searchAction.id==3">
              from result
            </span>
            <span>
              {{rule.searchColumn.label}} {{rule.searchOperator.label}}
            </span>
          </span>
          <span *ngIf="rule.valueType.name == 'date' && rule.dateValue">
            {{rule.dateValue.toDate() | date: "dd/MM/yyyy"}}
          </span>
          <span *ngIf="rule.valueType.name == 'string'">
            {{rule.strValue}}
          </span>
          <span *ngIf="rule.valueType.name == 'long'">
            {{rule.longValue}}
          </span>
          <span *ngIf="rule.valueType.name == 'boolean'">
            Is {{rule.booleanValue}}
          </span>
          <span *ngIf="rule.valueType.name == 'totalAmount' || rule.valueType.name == 'totalSchoolInvoice' || rule.valueType.name == 'remainingBalance' || rule.valueType.name == 'age' 
          || rule.valueType.name == 'duration'">
            {{rule.longValue}}
          </span>
          <span *ngIf="rule.searchColumn.id == 7 || rule.searchColumn.id == 26">
            {{rule.longValue | idToName: countries}}
          </span>
          <span *ngIf="rule.searchColumn.id == 12">
            {{rule.longValue | idToName: schools}}
          </span>
          <span *ngIf="rule.searchColumn.id == 13">
            {{rule.longValue | idToName: languages}}
          </span>
          <span *ngIf="rule.searchColumn.id == 22">
            {{rule.longValue | idToName: salesProductTypes}}
          </span>
          <span *ngIf="rule.searchColumn.id == 23">
            {{rule.longValue | idToName: programmeTypes}}
          </span>
          <span *ngIf="rule.searchColumn.id == 37">
            {{rule.longValue | idToName: boardTypes}}
          </span>
          <span *ngIf="rule.searchColumn.id == 38">
            {{rule.longValue! | idToName: roomTypes}}
          </span>
          <span *ngIf="rule.searchColumn.id == 54">
            {{rule.longValue! | idToName: accommodationTypes}}
          </span>
          <span *ngIf="rule.searchColumn.id == 56">
            {{rule.longValue! | idToName: counsellors}}
          </span>
          <span *ngIf="rule.valueType.name == 'today'">
            Today
            <span *ngIf="rule.relativeDate && rule.relativeDate.offset">
              <span *ngIf="rule.relativeDate.offset > 0">
                +
              </span>
              {{rule.relativeDate.offset}} days
            </span>
          </span>
          <p-button icon="pi pi-times" (onClick)="removeRule(i)"></p-button>
        </div>
        <div class="custom-search-and-options-container">
          <div class="custom-search-container">
            <p-dropdown [options]="searchActions" formControlName="action" optionLabel="name"></p-dropdown>
            <div class="custom-search-text-container">
              <span *ngIf="customSearchForm.value.action?.id==1 || customSearchForm.value.action?.id==2">
                to result
              </span>
              <span *ngIf="customSearchForm.value.action?.id==3">
                from result
              </span>
            </div>
            <p-dropdown [filter]="true" filterBy="label" [options]="searchColumns" formControlName="column"
              [style]="{'min-width':'220px'}" optionLabel="label" (onChange)="searchColumnChange()"></p-dropdown>
            <p-dropdown
              *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.searchDataType.name == 'string' || customSearchForm.value.column.searchDataType.name == 'long' 
              || customSearchForm.value.column.searchDataType.name == 'totalAmount' || customSearchForm.value.column.searchDataType.name == 'totalSchoolInvoice'
               || customSearchForm.value.column.searchDataType.name == 'remainingBalance' || customSearchForm.value.column.searchDataType.name == 'age' || customSearchForm.value.column.searchDataType.name == 'duration')"
              [options]="searchOperators" formControlName="operator" optionLabel="label"></p-dropdown>
            <p-dropdown id="list-element-dropdown"
              *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.searchDataType.name == 'listElement')"
              [options]="listElementOperators" formControlName="operator" optionLabel="label"></p-dropdown>
            <p-dropdown
              *ngIf="customSearchForm.get('column')!.value && customSearchForm.get('column')!.value.searchDataType.name == 'date'"
              [options]="dateSearchOperators" formControlName="operator" optionLabel="label"></p-dropdown>
            <p class="global-warning" *ngIf="hasInvalidInput">Invalid value</p>
            <div
              *ngIf="customSearchForm.value.column && (customSearchForm.value.column.searchDataType.name == 'boolean')">
              <p-dropdown placeholder="Select value" [options]="booleanValues" formControlName="value"></p-dropdown>
            </div>
            <p-dropdown
              *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 7 || customSearchForm.value.column.id == 26)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="countries" formControlName="value" optionLabel="name">
            </p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 12)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="schools" formControlName="value" optionLabel="name">
            </p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 13)"
              placeholder="Select value" [options]="languages" formControlName="value" optionLabel="name"></p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 22)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="salesProductTypes" formControlName="value"
              optionLabel="name">
            </p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 23)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="programmeTypes" formControlName="value"
              optionLabel="name">
            </p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 37)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="boardTypes" formControlName="value"
              optionLabel="name"></p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 38)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="roomTypes" formControlName="value" optionLabel="name">
            </p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 54)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="accommodationTypes" formControlName="value"
              optionLabel="name"></p-dropdown>
            <p-dropdown *ngIf="customSearchForm.get('column')!.value && (customSearchForm.value.column.id == 56)"
              placeholder="Select value" [filter]="true" filterBy="name" [options]="counsellors" formControlName="value"
              optionLabel="name"></p-dropdown>
            <input (keyup.enter)="customSearch()" pInputText formControlName="value"
              *ngIf="customSearchForm.value.column && (customSearchForm.value.column.searchDataType.name == 'string' || customSearchForm.value.column.searchDataType.name == 'long' 
              || customSearchForm.value.column.searchDataType.name == 'totalAmount' || customSearchForm.value.column.searchDataType.name == 'totalSchoolInvoice' 
              || customSearchForm.value.column.searchDataType.name == 'remainingBalance' || customSearchForm.value.column.searchDataType.name == 'age' || customSearchForm.value.column.searchDataType.name == 'duration')">
            <div *ngIf="customSearchForm.value.column && customSearchForm.value.column.searchDataType.name == 'date'">
              <div
                *ngIf="customSearchForm.value.operator.name != 'is null' && customSearchForm.value.operator.name != 'is not null'">
                <p-radioButton name="relative-date" [value]="false" formControlName="isRelativeDate"></p-radioButton>
                <p-calendar (onSelect)="updateFixedDate()" (keyup.enter)="customSearch()" formControlName="value"
                  [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" dateFormat="dd/mm/yy">
                </p-calendar>
                <p-button icon="pi pi-arrow-circle-right" (onClick)="customSearch()"
                  *ngIf="customSearchForm.value.isRelativeDate == false"></p-button>
              </div>
              <div class="relative-date-container"
                *ngIf="customSearchForm.value.operator.name != 'is null' && customSearchForm.value.operator.name != 'is not null'">
                <p-radioButton name="relative-date" [value]="true" formControlName="isRelativeDate"></p-radioButton>
                <div class="custom-search-text-container">
                  <p>
                    Today
                  </p>
                </div>
                <p-dropdown (onChange)="updateDateOffsetOption($event.value)" [options]="dateOffsetOptions"
                  formControlName="dateOffsetOption" optionLabel="label" [style]="{'minWidth':'55px', 'width': '55px'}">
                </p-dropdown>
                <div *ngIf="customSearchForm.value.dateOffsetOption.value != null">
                  <input (keyup.enter)="customSearch()" pInputText formControlName="dateOffset" class="offset-input">
                  <span>
                    Days
                  </span>
                </div>
                <p-button icon="pi pi-arrow-circle-right" (onClick)="customSearch()"
                  *ngIf="customSearchForm.value.isRelativeDate" class="relative-date-search-button"></p-button>
              </div>
              <div
                *ngIf="customSearchForm.value.operator.name == 'is null' || customSearchForm.value.operator.name == 'is not null'">
                <p-button icon="pi pi-arrow-circle-right" (onClick)="customSearch()"></p-button>
              </div>
            </div>
            <p-button icon="pi pi-arrow-circle-right" (onClick)="customSearch()"
              *ngIf="customSearchForm.value.column && customSearchForm.value.column.searchDataType.name != 'date'">
            </p-button>
          </div>
          <div class="option-buttons-container">
            <p-button label="Saved searches" (onClick)="bookingSearchService.showSavedSearches()"
              *ngIf="!bookingSearchService.isSavedSearchesVisible">
            </p-button>
            <p-button label="Hide saved searches" (onClick)="bookingSearchService.hideSavedSearches()"
              *ngIf="bookingSearchService.isSavedSearchesVisible">
            </p-button>
            <p-button styleClass="p-button-danger" label="Clear results" (onClick)="clearAllSearches()"></p-button>
          </div>
        </div>
      </div>
      <div *ngIf="activeItemId==2" class="csv-export-container">
        <div>
          <p-multiSelect [options]="exportOptions" optionLabel="name" [(ngModel)]="selectedExportOptions"></p-multiSelect>
          <p-button [icon]="csvDownloadIcon" label="Export Csv" (onClick)="exportBookings()" [disabled]="exportingCsv"></p-button>
          <p-button [icon]="xlsxDownloadIcon" label="Export Xlsx" (onClick)="exportBookingsXlsx()" [disabled]="exportingXlsx"></p-button>
          <p-button label="Export Weekly Csv" (onClick)="exportWeeklyReport()"></p-button>
          <p-button label="Export Student Email list" (onClick)="exportStudentEmails()"></p-button>
          <p-button [label]="productToReportLabel" (onClick)="exportProductToReport()"></p-button>
        </div>
        <div class="monthly-export-container">
            <div [formGroup]="monthlyReportForm">
              <p-dropdown formControlName="year" [options]="years"></p-dropdown>
              <p-dropdown formControlName="month" [options]="months"></p-dropdown>
            </div>
            <p-button [icon]="xlsxDownloadIcon" label="Export Monthly" [disabled]="exportingMonthlyXlsx" (onClick)="exportMonthlyXlsx()"></p-button>
        </div>

      </div>
    </div>
    <div *ngIf="activeItemId == 1 || activeItemId == 2">
      <div *ngIf="!bookingSearchService.bookings">
        <i class="pi pi-spin pi-spinner" style="font-size: 3em; color: grey;"></i>
      </div>
      <div *ngIf="!bookingSearchService.loading && bookingSearchService.bookings.length == 0">
        <span>No result</span>
      </div>
      <div *ngIf="bookingSearchService.bookings" class="booking-box">
        <ng-container *ngIf="bookingSearchService.bookings && bookingSearchService.recordNumber">
          <p>Found:
            <span *ngIf="!bookingSearchService.loading">
              {{bookingSearchService.recordNumber}}
            </span> bookings <span *ngIf="searchPerformance">({{searchPerformance}} sec)</span> <span
              *ngIf="bookingSearchService.loading">Loading</span>
          </p>
        </ng-container>
        <p-table selectionMode="single" [value]="bookingSearchService.bookings"
          *ngIf="bookingSearchService.recordNumber && bookingSearchService.recordsByPage" [lazy]="true"
          (onLazyLoad)="lazyLoad($event)" [paginator]="true" [loading]="bookingSearchService.loading"
          [rows]="bookingSearchService.recordsByPage" [totalRecords]="bookingSearchService.recordNumber"
          [rowsPerPageOptions]="pageRecordsOptions" paginatorPosition="both" [showLoader]="true">
          <ng-template pTemplate="header">
            <tr>
              <th [style]="{'width':'80px'}">ID
                <i class="pi pi-sort-alt" (click)="sortBookings('id')"></i>
              </th>
              <th id="active-head">Active
                <i class="pi pi-sort-alt" (click)="sortBookings('active')"></i>
              </th>
              <th [style]="{'width':'160px'}">First name
                <i class="pi pi-sort-alt" (click)="sortBookings('firstName')"></i>
              </th>
              <th [style]="{'width':'160px'}">Last name
                <i class="pi pi-sort-alt" (click)="sortBookings('lastName')"></i>
              </th>
              <th [style]="{'width':'200px'}">School
                <i class="pi pi-sort-alt" (click)="sortBookings('school')"></i>
              </th>
              <th [style]="{'width':'120px'}">Course
                <i class="pi pi-sort-alt" (click)="sortBookings('course')"></i>
              </th>
              <th [style]="{'width':'120px'}">Start
                <i class="pi pi-sort-alt" (click)="sortBookings('startDate')"></i>
              </th>
              <th [style]="{'width':'120px'}">End
                <i class="pi pi-sort-alt" (click)="sortBookings('endDate')"></i>
              </th>
              <th [style]="{'width':'110px'}">Language
                <i class="pi pi-sort-alt" (click)="sortBookings('language')"></i>
              </th>
              <th [style]="{'width':'100px'}">Duration
                <i class="pi pi-sort-alt" (click)="sortBookings('duration')"></i>
              </th>
              <th [style]="{'width':'120px'}">Paid
                <i class="pi pi-sort-alt" (click)="sortBookings('totalReceivedInEuro')"></i>
              </th>
              <th [style]="{'width':'120px'}">Due
                <i class="pi pi-sort-alt" (click)="sortBookings('dueAmount')"></i>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-booking>
            <tr [pSelectableRow]="booking">
              <td id="id">
                <a *ngIf="booking.lvmsId" routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.lvmsId}}
                </a>
                <a *ngIf="!booking.lvmsId" routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.id}}
                </a>
              </td>
              <td id="active">
                {{booking.active}}
              </td>
              <td id="first-name">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.firstName | titlecase}}
                </a>
              </td>
              <td id="last-name">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.lastName | titlecase}}
                </a>
              </td>
              <td>
                {{booking.school}}
              </td>
              <td>
                {{booking.course}}
              </td>
              <td id="start">
                {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
              </td>
              <td id="end">
                {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
              </td>
              <td>
                {{booking.language | titlecase}}
              </td>
              <td>
                {{booking.duration}}
              </td>
              <td>
                {{booking.totalReceivedInEuro}}
              </td>
              <td>
                {{booking.remainingBalanceInEuro}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div *ngIf="activeItemId==3">
      <app-bookings-with-users></app-bookings-with-users>
    </div>
  </div>